import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAPIWithoutAuth } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

export const fetchBanners = createAsyncThunk(
    'banner/fetchBanners',
    async (_, { rejectWithValue }) => {
        try {
            const response = await callAPIWithoutAuth(
                apiUrls.banners,
                {},
                "GET",
                {}
            );

            if (response?.data?.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response?.data?.message || 'Failed to fetch banners');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Network error');
        }
    }
);

export const fetchHomeBanners = createAsyncThunk(
    'banner/fetchHomeBanners',
    async (limit = 5, { rejectWithValue }) => {
        try {
            const params = { limit };
            const response = await callAPIWithoutAuth(
                apiUrls.homeBanners,
                params,
                "GET",
                {}
            );

            if (response?.data?.success) {
                return response.data.data;
            } else {
                return rejectWithValue(response?.data?.message || 'Failed to fetch home banners');
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Network error');
        }
    }
);

const bannerSlice = createSlice({
    name: 'banner',
    initialState: {
        banners: [],
        homeBanners: [],
        currentBanner: null,
        loading: false,
        homeBannerLoading: false,
        error: null
    },
    reducers: {
        clearBannerError: (state) => {
            state.error = null;
        },
        clearBanners: (state) => {
            state.banners = [];
            state.homeBanners = [];
            state.currentBanner = null;
        },
        setCurrentBanner: (state, action) => {
            state.currentBanner = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBanners.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBanners.fulfilled, (state, action) => {
                state.loading = false;
                state.banners = action.payload;
                state.currentBanner = action.payload?.[0] || null;
            })
            .addCase(fetchBanners.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchHomeBanners.pending, (state) => {
                state.homeBannerLoading = true;
                state.error = null;
            })
            .addCase(fetchHomeBanners.fulfilled, (state, action) => {
                state.homeBannerLoading = false;
                state.homeBanners = action.payload;
            })
            .addCase(fetchHomeBanners.rejected, (state, action) => {
                state.homeBannerLoading = false;
                state.error = action.payload;
            });
    }
});

export const { clearBannerError, clearBanners, setCurrentBanner } = bannerSlice.actions;
export default bannerSlice.reducer;